<template>
  <div>
    <b-form @submit.prevent="submit">
      <div class="text-center" v-show="isLoading">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>
      <b-row>
        <b-col cols="12" md="12">
          <b-alert variant="info" show dismissible>
            {{ $lang.message_random_number }}
          </b-alert>
        </b-col>
        <b-col cols="12" md="12">
          <b-form-group
            :label="$lang.azmoonLang.number_start"
            label-for="number_start"
            :label-cols="$config.azmoon.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.azmoonLang.number_start"
              :rules="$v.number_start.$params"
            />
            <b-form-input
              id="number_start"
              type="number"
              :autocomplete="$lang.azmoonLang.number_start"
              v-model="$v.number_start.$model"
              :state="$v.number_start.$dirty ? !$v.number_start.$error : null"
            >
            </b-form-input>
            <b-form-invalid-feedback id="number_start-feedback"
              >{{
                $lang.azmoonLang.error_required.replace(
                  "{0}",
                  $lang.azmoonLang.number_start
                )
              }}
            </b-form-invalid-feedback>

            <div class="invalid-feedback" v-if="!$v.number_start.numeric">
              {{
                $lang.error_numeric.replace(
                  "{0}",
                  $lang.azmoonLang.number_start
                )
              }}
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12">
          <b-form-group
            :label="$lang.azmoonLang.number_step"
            label-for="number_step"
            :label-cols="$config.azmoon.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.azmoonLang.number_step"
              :rules="$v.number_step.$params"
            />
            <b-form-input
              id="number_step"
              type="number"
              max="20"
              :autocomplete="$lang.azmoonLang.number_step"
              v-model="$v.number_step.$model"
              :state="$v.number_step.$dirty ? !$v.number_step.$error : null"
            >
            </b-form-input>
            <b-form-invalid-feedback id="number_step-feedback"
              >{{
                $lang.azmoonLang.error_required.replace(
                  "{0}",
                  $lang.azmoonLang.number_step
                )
              }}
            </b-form-invalid-feedback>
            <div class="invalid-feedback" v-if="!$v.number_step.numeric">
              {{
                $lang.error_numeric.replace("{0}", $lang.azmoonLang.number_step)
              }}
            </div>
            <b-form-invalid-feedback
              v-if="$v.number_step.required && !$v.number_step.maxLengh"
              id="name-feedback"
            >
              {{
                $lang.error_Value
                  .replace("{0}", $lang.azmoonLang.number_step)
                  .replace("{1}", "0")
                  .replace("{2}", "20")
              }}</b-form-invalid-feedback
            >
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12">
          <b-form-group
            :label="$lang.azmoonLang.distance_each_step"
            label-for="distance_each_step"
            :label-cols="$config.azmoon.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.azmoonLang.distance_each_step"
              :rules="$v.distance_each_step.$params"
            />
            <b-form-input
              id="distance_each_step"
              type="number"
              :autocomplete="$lang.azmoonLang.distance_each_step"
              v-model="$v.distance_each_step.$model"
              :state="
                $v.distance_each_step.$dirty
                  ? !$v.distance_each_step.$error
                  : null
              "
            >
            </b-form-input>
            <b-form-invalid-feedback id="distance_each_step-feedback"
              >{{
                $lang.azmoonLang.error_required.replace(
                  "{0}",
                  $lang.azmoonLang.distance_each_step
                )
              }}
            </b-form-invalid-feedback>
            <div class="invalid-feedback" v-if="!$v.distance_each_step.numeric">
              {{
                $lang.error_numeric.replace(
                  "{0}",
                  $lang.azmoonLang.distance_each_step
                )
              }}
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12" class="float-right">
          <div slot="footer" class="form-group form-btn">
            <b-button
              :disabled="isLoading"
              type="submit"
              size="md"
              variant="success"
            >
              <i class="fa fa-check"></i>
              {{ $lang.azmoonLang.submitButton }}
            </b-button>
            <b-button
              type="button"
              class="ml-2"
              size="md"
              variant="danger"
              @click="cancel"
            >
              <i class="fa fa-ban"></i>
              {{ $lang.azmoonLang.cancelButton }}
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import {
  required,
  numeric,
  minValue,
  maxValue,
} from "vuelidate/lib/validators";
export default {
  validations: {
    number_start: {
      numeric,
      required,
    },
    number_step: {
      numeric,
      required,
      minValue: minValue(0),
      maxValue: maxValue(20),
    },
    distance_each_step: {
      numeric,
      required,
    },
  },
  data() {
    return {
      isLoading: false,
      number_start: null,
      number_step: null,
      distance_each_step: null,
    };
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      this.isLoading = true;
      await this.createRandom();
      this.isLoading = false;
    },
    async createRandom() {
      let list_num = [];
      let num = parseInt(this.number_start);
      Array.from({ length: parseInt(this.number_step) }, (_, i) => {
        if (i !== 0) {
          num = num + parseInt(this.distance_each_step);
        }
        list_num.push({
          id: -100 + i,
          option_description: `${num}`,
        });
      });
      this.$emit("addRandomOption", list_num);
    },
  },
};
</script>

<style>
</style>